
import get from "lodash-es/get";
import "es6-promise";

import axios, { AxiosResponse } from "axios";
import Vue, { ComponentOptions } from "vue";
import Component from "vue-class-component";
import {
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Watch
} from "vue-property-decorator";

import { State, Getter, Action, Mutation, namespace } from "vuex-class";

import { ComputeJob, SampleCartItems } from "../model";
import {
  FETCH_JOBS,
  SET_PIPELINE_DESCRIPTION,
  SET_PIPELINE_PARAMS,
  SET_SAMPLES
} from "../store";
import { WebAPI } from "../web-api";

//import {AuthMixin} from "../index";

import { DummyJobList as _dummyJobList } from "../test-data";
import { Snackbar } from "../snackbar";
import PipelineParams from "./pipelines/rnasik/ui/PipelineParams.vue";
import { ILaxySampleCart, ILaxyFile } from "../types";

@Component({})
export default class JobList extends Vue {
  // Mixins<AuthMixin>(AuthMixin) {
  _DEBUG: boolean = false;

  public jobToCancel: string = "";
  public pagination: { [k: string]: number } = {
    page_size: 10,
    page: 1,
    count: 0
  };

  private _refreshPollerId: number | null = null;

  public submitting: boolean = false;
  public error_alert_message: string = "Everything is fine. 🐺";
  public snackbar_message: string = "Everything is fine. ☃";
  public snackbar_duration: number = 2000;

  get: Function = get;

  get jobs(): ComputeJob[] {
    return this.$store.state.jobs.jobs;
  }

  created() {
    //(new AuthMixin()).authenticate('google');
    //this.authenticate('google');

    this.refresh();
  }

  mounted() {
    this._refreshPollerId = window.setInterval(() => {
      this.refresh(null);
    }, 10000); // ms
  }

  beforeDestroy() {
    if (this._refreshPollerId != null) clearInterval(this._refreshPollerId);
  }

  routeTo(name: string, params: any = {}) {
    this.$router.push({ name: name, params: params });
  }

  get userId(): string | null {
    return this.$store.getters.userId;
  }

  getStatusColor(status: string) {
    const status_colors: any = {
      complete: "grey",
      running: "green",
      failed: "red",
      cancelled: "black"
    };

    let color: any = status_colors[status];
    if (color == null) {
      color = "black";
    }
    return color;
  }

  async onPagination(event: any) {
    const leaving_page = this.pagination.page;
    this.pagination.page = event.page;
    this.pagination.page_size = event.size;
    try {
      await this.refresh();
    } catch (error) {
      this.pagination.page = leaving_page;
      (this.$refs["pagination"] as any).currentPage = leaving_page;
    }
  }

  async refresh(successMessage: string | null = "Refreshed !") {
    try {
      this.submitting = true;
      await this.$store.dispatch(FETCH_JOBS, this.pagination);
      this.pagination.count = this.$store.state.jobs.total;
      this.submitting = false;
      if (successMessage) Snackbar.flashMessage(successMessage, 500);
    } catch (error) {
      console.log(error);
      this.submitting = false;
      this.error_alert_message = error.toString();
      this.openDialog("error_dialog");
      throw error;
    }
  }

  askCancelJob(id: string) {
    this.jobToCancel = id;
    this.openDialog("cancel_job_dialog");
  }

  async cancelJobConfirmed(id: string) {
    try {
      this.submitting = true;
      await WebAPI.cancelJob(id);
      await this.refresh(null);
      this.submitting = false;
      Snackbar.flashMessage(`Job ${id} cancelled.`);
    } catch (error) {
      console.log(error);
      this.submitting = false;
      this.error_alert_message = error.toString();
      this.closeDialog("cancel_job_dialog");
      this.openDialog("error_dialog");
      throw error;
    }

    this.closeDialog("cancel_job_dialog");
    this.refresh();
  }

  async cloneJob(id: string) {
    try {
      const response = await WebAPI.cloneJob(id);
      const pipelinerun_id = response.data.pipelinerun_id;
      const pipeline_name = response.data.pipeline;
      const samplecart_id = response.data.samplecart_id;

      const p_response = await WebAPI.getPipelineRun(pipelinerun_id);
      const s_response = await WebAPI.getSampleCart(samplecart_id);

      const pipelinerun = p_response.data;
      const samplecart = s_response.data;

      let samples = new SampleCartItems();
      samples.id = samplecart.id;
      samples.items = samplecart.samples;
      samples.name = samplecart.name;
      this.$store.commit(SET_SAMPLES, samples as SampleCartItems);

      this.$store.commit(SET_PIPELINE_PARAMS, pipelinerun.params);
      this.$store.commit(SET_PIPELINE_DESCRIPTION, pipelinerun.description);

      if (
        this.$store.get("pipelineParams@user_genome.fasta_url") ||
        this.$store.get("pipelineParams@user_genome.annotation_url")
      ) {
        this.$store.set("use_custom_genome", true);
      }

      // TODO: make a prop on RNASeqSetup to allow a jump to second or last step immediately
      this.$router.push({
        name: pipeline_name,
        params: { allowSkipping: "true" }
      });
    } catch (error) {
      console.log(error);
    }
  }

  openDialog(ref: string) {
    (this.$refs[ref] as MdDialog).open();
  }

  closeDialog(ref: string) {
    (this.$refs[ref] as MdDialog).close();
  }
}
